import UniversalChat from '../../components/common/UniversalChat';
import { useAuth } from '../../context/AuthContext';
import { usePermissions } from '../../hooks/usePermissions';

function EmpChatPage() {
  const { user } = useAuth();
  const { canWrite } = usePermissions();
  return <UniversalChat currentUserId={user?.userId} canWrite={canWrite('chat')} />;
}

export default EmpChatPage;
